import { render, staticRenderFns } from "./VanAnimation.vue?vue&type=template&id=1ee63474&scoped=true&"
import script from "./VanAnimation.vue?vue&type=script&lang=js&"
export * from "./VanAnimation.vue?vue&type=script&lang=js&"
import style0 from "./VanAnimation.vue?vue&type=style&index=0&id=1ee63474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee63474",
  null
  
)

export default component.exports